import Vue from 'vue'
import VueRouter from 'vue-router'

// 解决跳转异常
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

// 路由配置
const routes = [
  {
    path: '/',
    name: 'home',
    component: (resolve) => require(['@/views/exam/list'], resolve),
    meta: { title: '我的试卷', requireAuth: true }
  },
  {
    path: '/login',
    name: 'login',
    component: (resolve) => require(['@/views/login'], resolve),
    meta: { title: '登录' }
  },
  {
    path: '/exam/list',
    component: (resolve) => require(['@/views/exam/list'], resolve),
    meta: { title: '我的考试', requireAuth: true, keepAlive: true }
  },
  {
    path: '/exam/link',
    component: (resolve) => require(['@/views/exam/link'], resolve),
    meta: { title: '考试链接', requireAuth: true }
  },
  {
    path: '/exam/setting',
    component: (resolve) => require(['@/views/exam/setting'], resolve),
    meta: { title: '考试设置', requireAuth: true }
  },
  {
    path: '/markingPaper/list',
    component: (resolve) => require(['@/views/markingPaper/list'], resolve),
    meta: { title: '阅卷列表', requireAuth: true }
  },
  {
    path: '/markingPaper/qkksList',
    component: (resolve) => require(['@/views/markingPaper/qkksList'], resolve),
    meta: { title: '缺考考生列表', requireAuth: true }
  },
  {
    path: '/markingPaper/marking',
    component: (resolve) => require(['@/views/markingPaper/marking'], resolve),
    meta: { title: '打分页面', requireAuth: true }
  },
  {
    path: '/examPaper/list',
    component: (resolve) => require(['@/views/examPaper/list'], resolve),
    meta: { title: '试卷库', requireAuth: true, keepAlive: true }
  },
  {
    path: '/examPaper/add',
    component: (resolve) => require(['@/views/examPaper/add'], resolve),
    meta: { title: '创建试卷', requireAuth: true }
  },
  {
    path: '/exam/add',
    component: (resolve) => require(['@/views/examPaper/add'], resolve),
    meta: { title: '创建试卷', requireAuth: true }
  },
  {
    path: '/examPaper/edit',
    component: (resolve) => require(['@/views/examPaper/edit'], resolve),
    meta: { title: '试卷设计', requireAuth: true }
  },
  {
    path: '/exam/edit',
    component: (resolve) => require(['@/views/examPaper/edit'], resolve),
    meta: { title: '试卷设计', requireAuth: true }
  },
  {
    path: '/questions/list',
    component: (resolve) => require(['@/views/questions/list'], resolve),
    meta: { title: '试题库', requireAuth: true }
  },
  {
    path: '/questions/add',
    component: (resolve) => require(['@/views/questions/add'], resolve),
    meta: { title: '添加试题', requireAuth: true }
  },
  {
    path: '/questions/textAdd',
    component: (resolve) => require(['@/views/questions/textAdd'], resolve),
    meta: { title: '批量录入', requireAuth: true }
  },
  {
    path: '/user/list',
    component: (resolve) => require(['@/views/user/list'], resolve),
    meta: { title: '考生管理', requireAuth: true }
  },
  {
    path: '/report',
    component: (resolve) => require(['@/views/report'], resolve),
    meta: { title: '报表分析', requireAuth: true },
    children: [
      {
        path: '',
        component: (resolve) => require(['@/views/report/examScore'], resolve),
        meta: { title: '考试成绩', requireAuth: true }
      },
      {
        path: 'examScore',
        component: (resolve) => require(['@/views/report/examScore'], resolve),
        meta: { title: '考试成绩', requireAuth: true }
      },
      {
        path: 'ksfxPage',
        component: (resolve) => require(['@/views/report/ksfxPage'], resolve),
        meta: { title: '考试分析', requireAuth: true }
      },
      {
        path: 'stfxPage',
        component: (resolve) => require(['@/views/report/stfxPage'], resolve),
        meta: { title: '试卷分析', requireAuth: true }
      }
    ]
  },
  {
    path: '/examinee/list',
    component: (resolve) => require(['@/views/examinee/list'], resolve),
    meta: { title: '我的考试', requireAuth: true }
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
